export default "__VITE_ASSET__BJRYkGmZ__"